import { AppIconButton, AppTextarea } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { getCommentError, isCommentValid } from '@opportunities/-lib/opportunityValidation'
import { RefreshCw, Send } from 'lucide-react'
import { useState } from 'react'
import { FIELD_MAX_LENGTHS } from 'shared'
import { toast } from 'sonner'
import { handleCommentChange } from '../utils'

interface CommentInputProps {
  onCreate: (comment: string) => Promise<void>
  onReload: () => void
  isRefetching: boolean
  isCreating?: boolean
}

/**
 * コメント入力フォームコンポーネント
 *
 * 新規コメント投稿とリロード機能を担当
 */
export function CommentInput({ onCreate, onReload, isRefetching, isCreating = false }: CommentInputProps) {
  const [newComment, setNewComment] = useState('')
  const [newCommentError, setNewCommentError] = useState<string | null>(null)

  const handleSubmit = async () => {
    const error = getCommentError(newComment)
    if (error) {
      toast.error(error)
      return
    }
    await onCreate(newComment)
    setNewComment('')
    setNewCommentError(null)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
      e.preventDefault()
      handleSubmit()
    }
  }

  return (
    <div className='border-t p-4'>
      <div className='relative'>
        <AppTextarea
          value={newComment}
          label='コメントを入力'
          helpText='Enter/改行、Ctrl+Enter/送信'
          onChange={(e) => handleCommentChange(e.target.value, setNewComment, setNewCommentError)}
          onKeyDown={handleKeyDown}
          rows={1}
          disabled={isCreating}
          maxLength={FIELD_MAX_LENGTHS.COMMENT}
          showCharCount
          limitHeight='sm'
          error={newCommentError ?? undefined}
          className='pr-20'
        />
        <div className='absolute right-2 bottom-6 flex gap-1'>
          <AppIconButton description='送信' onClick={handleSubmit} disabled={isCreating || !isCommentValid(newComment)}>
            <Send />
          </AppIconButton>
          <AppIconButton description='再読み込み' onClick={onReload} disabled={isRefetching}>
            <RefreshCw />
          </AppIconButton>
        </div>
      </div>
    </div>
  )
}
